export const RESET_SERVICE_ERRORS = 'RESET_SERVICE_ERRORS';
export const ERROR_PACKAGES = 'ERROR_PACKAGES';
export const ERROR_REPAIR = 'ERROR_REPAIR';
export const ERROR_MAINTENANCE = 'ERROR_MAINTENANCE';
export const ERROR_RECALL = 'ERROR_RECALL';
export const ERROR_DECLINED = 'ERROR_DECLINED';

export const ERROR_DAY_TIME = 'ERROR_DAY_TIME';

export const ERROR_APPT_OPTION = 'ERROR_APPT_OPTION';

export const ERROR_NO_CAPACITY = 'ERROR_NO_CAPACITY';

export const ERROR_FROM_CLUTCH = 'ERROR_FROM_CLUTCH';



// WEBPACK FOOTER //
// ./src/store/reducers/errors/actionTypes.js